































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { download, Page } from 'yellowfin-ui-lib';
import AnagraficaSearch from '@/packages/albo/anagrafica/AnagraficaSearch.vue';
import AnagraficaTable from '@/packages/albo/anagrafica/AnagraficaTable.vue';
import { AnagraficaService } from '@/data/services/anagrafica.service';
import { Anagrafica, AnagraficaRequest } from '@/data/models/anagrafica.model';
import { merge } from '@/data/utils/helpers';
import { ExportField } from '@/data/models/export.model';
import ExportModal from '../ExportModal.vue';

@Component({
	components: {
		AnagraficaSearch,
		AnagraficaTable
	}
})
export default class AnagraficaList extends Vue {

	@Inject('AnagraficaService') anagraficaService!: AnagraficaService;

	@Prop() elencoid!: string;
	@Prop() albobase!: string;


	data: Anagrafica[] = [];
	loading = false;

	searchparam!: AnagraficaRequest;
	page: Page = new Page(20);

	get showExport() {
		return (process.env.VUE_APP_ALBO_EXPORT as string) === 'true'
	}

	search() {
		this.loading = true;

		if(this.elencoid){
			this.searchparam.idelenco = this.elencoid;
		}
		const searchreq = this.anagraficaService.search(this.searchparam, this.page);
		const countreq = this.anagraficaService.searchCount(this.searchparam);
		Promise.all([searchreq, countreq]).then(results => {
			this.data = results[0];
			this.page.setTotal(results[1].cnt);
		}).finally(() => {
			this.loading = false;
		})
	}

	onSearchChange(searchparam: AnagraficaRequest) {
		this.searchparam = searchparam;
		this.search();
	}

	onPageChange(page: number) {
		this.page.setPageNumber(page - 1);
		this.search();
	}

	exportSearch() {
		// @ts-ignore
		const modal = this.$oruga.modal.open({
			parent: this,
			component: ExportModal,
			events: {
				'submit': (fields: ExportField) => {
					const param: AnagraficaRequest = merge({}, this.searchparam);
					console.log(fields);
					param.export = fields;
					this.anagraficaService.export(param).then(result => {
						modal.close();
						download(result, 'export.csv');
					});
				}
			}
		});
		
	}

	beforeMount() {
		this.onSearchChange(new AnagraficaRequest())
	}
}
